import { Schedule, ScheduleDto } from "../models/schedule/schedule";
import client from "../helpers/network/client";
import { useCallback } from "react";
import { useTeachers } from "../states/cache-state/useTeachers";
import { useSchoolApi } from "./school-api";
import useCache from "../hooks/useCache";

const getSchedule = (schoolId: string, teacherId: string) =>
  client
    .get<ScheduleDto[]>(`school/${schoolId}/teacher/${teacherId}/schedule`)
    .then((r) => r.data)
    .then((schedules) => schedules[0]);

export const useSchedulerApi = () => {
  const { getTeacher } = useTeachers();
  const { getSchool } = useSchoolApi();
  const { fetchWithCache } = useCache();

  const _getSchedule = useCallback(
    async (schoolId: string, teacherId: string) => {
      const schedule = await fetchWithCache(
        { type: "schedule", contexts: [schoolId, teacherId] },
        () => getSchedule(schoolId, teacherId),
      );
      const teacher = await getTeacher(schedule.teacherEmail);
      const school = await getSchool(schoolId);
      return Schedule.createFromScheduleDto(schedule, teacher, school);
    },
    [fetchWithCache, getTeacher, getSchool],
  );

  return {
    getSchedule: _getSchedule,
  };
};
